import {Component, Input, OnInit} from '@angular/core';
import {Group, Language} from "../../../../types/interfaces";
import {Router} from "@angular/router";
import {TranslocoService} from "@jsverse/transloco";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";
import {AuthService} from "../../../../services/mygreencountry/auth.service";
import {LocaleService} from "../../../../services/mygreencountry/locale.service";
import {EnglishLevelsComponent} from "../../modals/english-levels/english-levels.component";
import {ModalController, PopoverController} from "@ionic/angular";
import {PersistenceService} from "../../../../services/mygreencountry/persistence.service";
import {ParentService} from "../../../../services/mygreencountry/parent.service";
import {FAQ_LINK, AGREEMENT_LINK, PAYMENT_LINK, LANGUAGES} from "../../../constants";

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
})
export class MobileMenuComponent implements OnInit {

    public currentPaidGroups: Group[] | undefined = undefined;
    public showStudentActions: boolean | undefined = undefined;
    protected readonly FAQ_LINK = FAQ_LINK;
    protected readonly AGREEMENT_LINK = AGREEMENT_LINK;
    protected readonly PAYMENT_LINK = PAYMENT_LINK;

    currentGroupsLinks$ = this.parentService.getCurrentGroupsLinks();

    constructor(
        private router: Router,
        public myGcService: MyGreenCountry,
        private authService: AuthService,
        private modalCtrl: ModalController,
        private popoverController: PopoverController,
        private parentService: ParentService,
    ) {
    }

    ngOnInit() {
        // let activeTabGroupsLinks = this.persistenceService.get('activeTabGroupsLinks') as Group[];
        let activeTabGroupsLinks = this.currentGroupsLinks$.getValue() as Group[];

        if (activeTabGroupsLinks) {
            this.currentPaidGroups = activeTabGroupsLinks;
            this.showStudentActions = this.currentPaidGroups.length > 0;
        }
    }

    goTo(urls: Array<string>, queryParams: any = {}) {

        this.router.navigate(urls, {queryParams});
    }

    logout() {
        this.DismissClick();
        this.authService.logout();
        this.router.navigate(['/login']);
    }

    async DismissClick() {
        await this.popoverController.dismiss();
    }

    openUrl(url: string) {
        this.myGcService.openUrl(url)

    }

    async closeModalAndNavigate(route: string) {
        await this.DismissClick();

        await this.router.navigate([route]);
    }

    async openEnglishLevelModal() {
        const modal = await this.modalCtrl.create({
            component: EnglishLevelsComponent,
            cssClass: 'auto-height',
            componentProps: {}
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }
}
